const state = {
  images: [],
  showimage: null,
};

const getters = {
  images: state => {
    return state.images;
  },
  isShow: state => {
    return state.showimage;
  }
};

const mutations = {
  push(state,
    images
  ) {
    state.images = images
  },
  show(state, image) {
    state.showimage = image
  },
  showed(state){
    state.showimage = null;
  },
  clear(state) {
    state.images = [];
    state.showimage = null;
  }

};

export default {
  namespaced: true,
  getters,
  state,
  mutations
};